import { Component, computed, input } from '@angular/core';
import { BaseCode } from '@app/modules/smart-devices/data/smart-devices.interface';

@Component({
  selector: 'sbnb-task-pin-code',
  templateUrl: './task-pin-code.component.html',
  styleUrl: './task-pin-code.component.scss',
})
export class TaskPinCodeComponent {
  code = input.required<BaseCode>();

  latestStatus = computed(() => {
    if (!this.code().statuses?.length) {
      return undefined;
    }

    return this.code().statuses.find((status) => status.is_latest === true);
  });

  name = computed(() => {
    if (!this.latestStatus()) {
      return 'Cancelled Externally';
    }

    return this.latestStatus().name;
  });

  variant = computed(() => {
    if (!this.latestStatus()) {
      return 'gray';
    }

    switch (this.latestStatus().name) {
      case 'Created':
        return 'gray';
      case 'Visible on lock':
      case 'Active':
        return 'success';
      default:
        return 'gray';
    }
  });

  appearance = computed(() => {
    if (!this.latestStatus()) {
      return 'subtle';
    }

    switch (this.latestStatus().name) {
      case 'Created':
        return 'subtle';
      case 'Visible on lock':
        return 'subtle';
      case 'Active':
        return 'solid';
      default:
        return 'subtle';
    }
  });

  value = computed(() => {
    if (!this.code().code) {
      return 'Cancelled';
    }

    return this.code().code;
  });
}
